export default __webpack_public_path__ + "static/media/super_next_icon.2e188202.svg";